import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import Summary from "../../../ui/Summary";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
/*バリデーション */
import { validateMaxlength } from "../../../../utils/validate";

const SearchFrom = ({ setSearchCondition }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  //検索条件リセット
  const resetCondition = () => {
    setValue("category_name", "");
  };

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="カテゴリーを絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="category_name"
                  errors={errors}
                  label="カテゴリー名"
                  placeholder="カテゴリー名"
                ></TextField>
              </tr>
            </table>
            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default SearchFrom;
